import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Rule = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  color: ${props => props.theme.palette.text.light};

  span {
    font-size: ${props => props.theme.typography.sizes.caption};
  }
`;
